module.exports = __webpack_public_path__ + "static/financial_access10-bb850953fd7f5ecb80d34b539499f71b.png";